import { render, staticRenderFns } from "./PageFourteenth.vue?vue&type=template&id=57960f6f&scoped=true"
import script from "./PageFourteenth.vue?vue&type=script&lang=js"
export * from "./PageFourteenth.vue?vue&type=script&lang=js"
import style0 from "./PageFourteenth.vue?vue&type=style&index=0&id=57960f6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57960f6f",
  null
  
)

export default component.exports